<div class="content-container">
  @if (plan$ | async; as plan) {
  <div class="table-content rounded-sm">
    <div class="flex flex-1 column">
      @if (plan.isLoading && !plan.response) {
      <div class="loading">
        <app-loading />
      </div>
      } @else if (plan.response) {
      <div class="table" [style.height]="planTableService.tableHeight()">
        @for (record of plan.response.plans; track $index; let last = $last) {
        <div class="table-row" [ngClass]="{ underlined: !last }">
          <div class="cell clickable" (click)="navigateToPlanMonth(record)">
            {{ record.effectivePeriod | dateToString }}
          </div>
          <div class="cell">
            <input
              [ngClass]="{
                highlight: isCellEdited(record.planID, 'vmax', record.vmax),
                danger: projExceededVmax(record.proj, record.vmax)
              }"
              type="text"
              inputmode="numeric"
              [(ngModel)]="record.vmax"
              (keydown)="onKeyDown($event, record, 'vmax', plan.response)"
            />
          </div>
          <div class="cell">
            <input
              [ngClass]="{
                highlight: isCellEdited(record.planID, 'proj', record.proj),
                danger: projExceededImax(record.proj, record.imax) || projExceededVmax(record.proj, record.vmax)
              }"
              type="text"
              inputmode="numeric"
              [(ngModel)]="record.proj"
              (keydown)="onKeyDown($event, record, 'proj', plan.response)"
            />
          </div>
          <div
            class="cell"
            [ngClass]="{ success: imaxTargetReached(record.imax), danger: projExceededImax(record.proj, record.imax) }"
          >
            {{ record.imax | minutesToTime }}
          </div>
        </div>
        }
      </div>
      }
    </div>
    @if (planUnsaved && plan.response) {
    <div class="controls">
      <app-button
        @fadeInOut
        class="flex-1"
        icon="pi pi-undo"
        label="Revert"
        [outlined]="globalService.theme() === 'dark'"
        (click)="revertChanges()"
      />
      <app-button
        @fadeInOut
        class="flex-1"
        icon="pi pi-save"
        label="Save"
        severity="success"
        [outlined]="globalService.theme() === 'dark'"
        [disabled]="globalService.offline()"
        (click)="saveChanges(plan.response.plans)"
      />
    </div>
    }
  </div>
  <app-refresh
    class="width-100"
    [refreshing]="plan.isLoading"
    (refresh)="getData(true)"
    [lastUpdatedText]="planTableService.lastUpdatedText()"
  />
  }
</div>
